import { ReferenceNumberInputModes } from '@nova/core';
import { computed, unref } from 'vue';
import { t, $locale } from '@satellite/plugins/translator';

export function useFieldRules(settingsObj, { required, positiveInteger, maxItems }) {
  const settings = computed(() => unref(settingsObj) || {});

  const callRuleFactory = (factory, ...args) =>
    typeof factory === 'function' ? factory(...args) : [];

  const multiRefNumValidationRules = computed(() => {
    if (!required || !settings.value) {
      return [];
    }
    const rules = [];
    const displayName = settings.value.displayName || '';

    if (required && settings.value.isRequired) {
      rules.push(...callRuleFactory(required, displayName));
    }

    if (maxItems && settings.value.referenceNumbersMaximumCount) {
      rules.push(...callRuleFactory(maxItems, settings.value.referenceNumbersMaximumCount));
    }
    return rules;
  });

  const refNumValidationRules = computed(() => {
    const loc = $locale?.();
    if (loc && typeof loc === 'object' && 'value' in loc) void loc.value;

    if (!positiveInteger || !settings.value) {
      return [];
    }
    const isNumeric = settings.value.inputMode === ReferenceNumberInputModes.MODE_NUMERIC;
    return isNumeric
      ? [...callRuleFactory(positiveInteger, t('global.errors.isNotAValidNumber'))]
      : [];
  });

  return {
    multiRefNumValidationRules,
    refNumValidationRules
  };
}
